<template>
    <div class="container">
        <img src="../assets/images/user-pic.png" alt="" class="user-pic">
        <div class="edit-list">
            <div class="edit-item">
                <div class="item-name">昵称</div>
                <div class="item-content">
                    <div class="point" v-if="nickname==''||!nickname" @click="nicknameModal=true">请输入</div>
                    <div class="item-text" v-else>{{nickname}}</div>
                    <img src="../assets/images/edit-more.png" alt="" @click="nicknameModal=true">
                </div>
            </div>
            <div class="edit-item">
                <div class="item-name">性别</div>
                <div class="item-content">
                    <div class="point" v-if="gender==''||!gender" @click="genderModal=true">请选择</div>
                    <div class="item-text" v-else>{{gender}}</div>
                    <img src="../assets/images/edit-more.png" alt="" @click="genderModal=true">
                </div>
            </div>
            <div class="edit-item">
                <div class="item-name">出生日期</div>
                <div class="item-content">
                    <div class="point" v-if="birthday==''||!birthday" @click="birthdayModal=true">请选择</div>
                    <div class="item-text" v-else>{{birthday}}</div>
                    <img src="../assets/images/edit-more.png" alt="" @click="birthdayModal=true">
                </div>
            </div>
        </div>
        <div class="nickname-modal" v-show="nicknameModal">
            <div class="nickname-content">
                <div class="modal-title">设置昵称</div>
                <div class="nickname-box">
                    <input type="text" class="nickname" v-model="nickname" @input="checkName">
                    <img src="../assets/images/empty-nickname.png" alt="" class="empty-nickname" @click="emptyName">
                </div>
                <div class="err-point" v-show="isErr">*请按要求输入正确的昵称</div>
                <div class="point-text">支持汉字、字母、数字，最多10个字符</div>
                <div class="btns">
                    <div class="cancel" @click="cancel">取消</div>
                    <div class="sure" @click="sure">确定</div>
                </div>
            </div>
        </div>
        <div class="gender-modal" v-show="genderModal">
            <div class="gender-content">
                <div class="gender-head">
                    <div class="cancel-gender" @click="cancelGender">取消</div>
                    <div class="gender-title">选择性别</div>
                    <div class="sure-gender" @click="sureGender">确定</div>
                </div>
                <div :class="gender=='男' ? 'gender-classify-ac':'gender-classify'" @click="gender='男'">男</div>
                <div :class="gender=='女' ? 'gender-classify-ac':'gender-classify'" @click="gender='女'">女</div>
            </div>
        </div>
        <div class="birthday-modal" v-show="birthdayModal">
            <div class="birthday-content">
                <DatetimePicker
                    v-model="currentDate"
                    type="date"
                    title="请选择出生日期"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="sureBirthday"
                    @cancel="cancelBirthday"
                >
                    <slot>
                        <div class="birthday-head">
                            <div class="head-box">
                                <div class="birthday-cancel" @click="cancelBirthday">取消</div>
                                <div class="birthday-title">请选择出生日期</div>
                                <div class="birthday-sure" @click="sureBirthday">确定</div>
                            </div>                           
                        </div>
                    </slot>                
                </DatetimePicker>
            </div>
        </div>        
    </div>
</template>

<script>
import 'vant/lib/index.css'
import { DatetimePicker  } from 'vant';
import {update_userinfo,user_info} from '../api/my'
export default {
    props: {},
    components: {
        DatetimePicker
    },
    data() {
        return {
            nicknameModal:false,
            isErr:false,
            nickname:'',
            genderModal:false,
            gender:'',
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(2045, 10, 1),
            currentDate: new Date(2000, 0, 0),
            birthday:'',
            birthdayModal:false,
            loginPhone:'',
        };
    },
    computed: {
        
    },
    watch: {},
    created() {
        let phone=localStorage.getItem('phone')
        this.loginPhone=phone 
        this.userinfo()
    },
    mounted() {},
    methods: {
        userinfo(){
            user_info(this.loginPhone).then(res=>{
                this.nickname=res.data.userinfo.nickname;
                this.gender=res.data.userinfo.gender;
                this.birthday=res.data.userinfo.birthday;
            })
        },
        updateUserinfo(){
            update_userinfo(this.loginPhone,this.nickname,this.gender,this.birthday).then(res=>{
                if(res.status==200){
                    this.$toast('修改成功');
                }
            })
        },
        emptyName(){
            this.nickname='';
            this.isErr=false;
        },
        checkName(){            
            if(this.nickname.length>10){
                this.isErr=true;
                return this.$toast('请按要求输入正确的昵称');
            }
            const regex=/^[A-Za-z0-9\u4e00-\u9fa5]+$/
            if (!regex.test(this.nickname)){
                this.isErr=true;
                return this.$toast('请按要求输入正确的昵称');    
            }
            this.isErr=false;
        },
        sure(){
            if(this.nickname==''){
                this.isErr=true;
                return this.$toast('请按要求输入正确的昵称');
            }
            if(this.nickname.length>10){
                this.isErr=true;
                return this.$toast('请按要求输入正确的昵称');
            }
            const regex=/^[A-Za-z0-9\u4e00-\u9fa5]+$/
            if (!regex.test(this.nickname)){
                this.isErr=true;
                return this.$toast('请按要求输入正确的昵称');    
            }
            this.nicknameModal=false
            this.updateUserinfo()
        },
        cancel(){
            this.nicknameModal=false;
        },
        sureGender(){
            this.genderModal=false;
            this.updateUserinfo()
        },
        cancelGender(){
            this.genderModal=false;
        },
        sureBirthday(){
            let date=new Date(this.currentDate);
            let year=date.getFullYear();
            let month=date.getMonth()+1;
            let day=date.getDate();
            if(month<10){
                month='0'+month
            }
            if(day<10){
                day='0'+day
            }
            let choiceDate=year+'-'+month+'-'+day
            this.birthday=choiceDate;
            this.birthdayModal=false;
            this.updateUserinfo()
        },
        cancelBirthday(){
            this.birthdayModal=false;
        }
    },
};
</script>

<style scoped lang="less">
.container{
    padding: 16px;
}
.user-pic{
    display: block;
    width: 100px;
    height: 100px;
    margin: 34px auto;
    border-radius: 50%;
}
.edit-list{
    margin-top: 60px;
}
.edit-item{
    height: 70px;
    padding: 0px 12px;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    border-radius: 10px;
    margin-bottom: 10px;
}
.item-name{
    height: 70px;
    line-height: 70px;
    font-size: 14px;
    color: #999999;
    font-weight: 500;
}
.item-content{
    height: 70px;
    display: flex;
    justify-content: flex-start;
}
.point{
    height: 70px;
    line-height: 70px;
    font-size: 14px;
    font-weight: 500;
    color: #999999;
}
.item-text{
    height: 70px;
    line-height: 70px;
    font-size: 14px;
    font-weight: 500;
    color: #333;
}
.item-content img{
    display: block;
    height: 16px;
    width: 16px;
    margin-top: 27px;
    margin-left: 3px;
}
.nickname-modal{
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0px;
    top: 0px;
    background-color: rgba(0, 0, 0, 0.5);
}
.nickname-content{
    padding: 30px;
    background-color: #fff;
    border-radius: 10px;
    width: 250px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.modal-title{
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 20px;
    color: #333;
    font-weight: 500;
    margin-bottom: 30px;
}
.nickname-box{
    background-color: #F2F6F6;
    height: 60px;
    padding: 0px 20px;
    border-radius: 30px;
    display: flex;
    justify-content: space-between;
}
.nickname{
    height: 30px;
    line-height: 30px;
    display: block;
    margin-top: 15px;
    border: none;
    outline: none;
    background-color: #F2F6F6;
    font-size: 14px;
    font-weight: 500;
    color: #333;
}
.empty-nickname{
    display: block;
    height: 20px;
    margin-top: 20px;
}
.err-point{
    height: 12px;
    line-height: 12px;
    font-size: 12px;
    color: #FF0000;
    margin: 10px 0px;
}
.point-text{
    height: 12px;
    line-height: 12px;
    font-size: 12px;
    color: #999999;
    margin: 10px 0px;
}
.btns{
    margin-top: 20px;
    height: 48px;
    display: flex;
    justify-content: space-between;
}
.cancel{
    width: 48%;
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    background-color: #F2F6F6;
    border-radius: 24px;
}
.sure{
    width: 48%;
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background-color: #01D6D6;
    border-radius: 24px;
}
.gender-modal{
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0px;
    top: 0px;
    background-color: rgba(0, 0, 0, 0.5);
}
.gender-content{
    background-color: #fff;
    border-radius: 10px 10px 0px 0px;
    padding: 20px 0px;
    position: absolute;
    left: 0px;
    bottom: 0px;
    z-index: 10;
    width: 100%;
}
.gender-head{
    height: 22px;
    display: flex;
    justify-content: space-between;
    padding: 0px 16px;
    margin-bottom: 30px;
}
.cancel-gender{
    height: 22px;
    line-height: 22px;
    font-size: 16px;
    color: #333;
}
.gender-title{
    height: 22px;
    line-height: 22px;
    font-size: 18px;
    color: #333;
    font-weight: 500;
}
.sure-gender{
    height: 22px;
    line-height: 22px;
    font-size: 16px;
    color: #01D6D6;
}
.gender-classify{
    height: 56px;
    line-height: 56px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #999999;
    border-bottom: 1px solid #F6F6F6;
}
.gender-classify-ac{
    height: 56px;
    line-height: 56px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    border-bottom: 1px solid #F6F6F6;
}
.birthday-modal{
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0px;
    top: 0px;
    background-color: rgba(0, 0, 0, 0.5);
}
.birthday-content{
    background-color: #fff;
    border-radius: 10px 10px 0px 0px;
    padding: 20px 0px;
    position: absolute;
    left: 0px;
    bottom: 0px;
    z-index: 10;
    width: 100%;
}
.birthday-head{
    display: block;
    height: 22px;
    width: 100%;    
}
.head-box{
    display: flex;
    justify-content: space-between;    
    padding:0px 16px;
}
.birthday-cancel{
    height: 22px;
    line-height: 22px;
    color: #333;
    font-size: 16px;
}
.birthday-title{
    height: 22px;
    line-height: 22px;
    color: #333;
    font-size: 18px;
    font-weight: 500;
}
.birthday-sure{
    height: 22px;
    line-height: 22px;
    color: #01D6D6;
    font-size: 16px;
}
</style>

